import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {BiSolidSelectMultiple} from "react-icons/bi";
import EmptyPic from "../../Assets/Images/nophoto.png";
import {useNavigate} from "react-router-dom";
import {LiaUserEditSolid} from "react-icons/lia";

const currencyFormat = Intl.NumberFormat('en-US');
function CreateVendor() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [title, setTitle] = React.useState('');
    const [brief, setBrief] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [description, setDescription] = React.useState('');
    // const [officePhone, setOfficePhone] = React.useState([]);
    const [supportPhone, setSupportPhone] = React.useState('');
    const [logo, ] = React.useState(null);
    const [fileLogo, setFileLogo] = React.useState(null);
    const [picLogo, setPicLogo] = React.useState(EmptyPic);
    const [cover, ] = React.useState(null);
    const [fileCover, setFileCover] = React.useState(null);
    const [picCover, setPicCover] = React.useState(EmptyPic);
    const [acceptRules, setAcceptRules] = React.useState(0);
    const [content, setContent] = React.useState('');
    const [showRules, setShowRules] = React.useState(false);
    const [cashDiscount, setCashDiscount] = React.useState(0);
    const [chequeDeadline, setChequeDeadline] = React.useState(45);
    const [minPurchase, setMinPurchase] = React.useState(0);
    const [cooperationPercent, setCooperationPercent] = React.useState(0);
    const [thresholdDiscount, setThresholdDiscount] = React.useState(0);
    const [discountPercent, setDiscountPercent] = React.useState(0);
    const [tax, setTax] = React.useState(0);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }
        API.getUserInfo()
            .then((response) => {
                setIsLoaded(true);
                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
        API.getContent('قوانین-تامین-کننده')
            .then((response) => {
                setContent(response.data)
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }


    const onClickSaveButton = () => {
        if(!acceptRules) {
            toast.error('قوانین و مقررات سامانه را بایستی بپذیرید');
            return false
        }
        if(cooperationPercent < 0.1) {
            toast.error('وارد کردن درصد سهم سامانه اجباری است');
            return false
        }
        setIsLoaded(false);

        const formData = new FormData();
        if (fileLogo)
            formData.append('logo', fileLogo);
        if (fileCover)
            formData.append('cover', fileCover);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('brief', brief);
        formData.append('support_phone', supportPhone);
        formData.append('address', address);
        formData.append('province_id', 2);
        formData.append('city_id', 1);
        formData.append('vendor_id', window.localStorage.getItem("vendor"));
        formData.append('cash_discount_percent', cashDiscount);
        formData.append('cheque_deadline', chequeDeadline);
        formData.append('minimum_order_amount', minPurchase);
        formData.append('cooperation_percent', cooperationPercent);
        formData.append('discount_percent', discountPercent);
        formData.append('tax_percent', tax);
        formData.append('threshold_discount', thresholdDiscount);

        API.storeVendor(formData)
            .then((response) => {
                toast.success(response.message);
                window.localStorage.setItem("vendorTitle", title);
                window.localStorage.setItem("vendor", response.data.id);
                setTimeout (() => {
                    window.location.replace(`/vendor/manage`);
                },1500)
            })
            .catch((error) => {
                setIsLoaded(true);
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });
    }

    const onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPicLogo(reader.result);
            setFileLogo(event.target.files[0])
        };
    }
    const onFileChangeCover = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPicCover(reader.result);
            setFileCover(event.target.files[0])
        };
    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            {
                showRules &&

            <section className="container-fluid  mt-3 py-3 rtl px-0 mx-0 services-list rules-box ">
                <div className="row mx-0 px-0">
                    <div className="col-12 px-0 text-center">
                        <img src={content.image} alt={content.title} className='w-100'/>
                    </div>
                    <div className="col-12 text-center fw-bold mt-3 text-big-1 border-bottom pb-3">
                        {content.title}
                    </div>
                    <div className="col-12 text-justify p-4">
                        <p  dangerouslySetInnerHTML={{ __html: content.content }}></p>
                    </div>
                    <div className="col-7 py-4 mb-4">
                        <button className="btn btn-primary  w-100"
                        onClick={() => {
                            setAcceptRules(1 )
                            setShowRules(false)}}
                        >
                            قوانین را مطالعه کرده و می پذیرم
                        </button>
                    </div>
                    <div className="col-5 py-4 mb-4">
                        <button className="btn btn-danger  w-100"
                        onClick={() => {
                            setAcceptRules(0 )
                            setShowRules(false)}}
                        >
                            عدم پذیرش قوانین
                        </button>
                    </div>
                </div>

            </section>
            }
            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>

                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home`)}

                                    >
                                        <LuClipboardList className='mx-2'/>
                                        لیست                                        سفارش ها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         id='active'
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}
                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
     <div className="col-12 item "
                                         onClick={() => navigate(`/product-reports`)}

                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش  فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/wallet`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 product-form">
                        <div className="row">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                                ثبت نام مجموعه
                            </div>
                            <div className="col-md-6 mb-3 ">

                                <img alt="Logo"
                                     src={(logo && !fileLogo) ? logo : picLogo}
                                     width={85} className='rounded'/>
                                <span className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر لوگوی جدید
                                                 <input type="file" onChange={onFileChange}/>
                                                </label>
                                            </span>
                            </div>
                            <div className="col-md-6 mb-3 ">

                                <img alt="Logo"
                                     src={(cover && !fileCover) ? cover : picCover}
                                     width={85} className='rounded'/>
                                <span className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر کاور جدید
                                                 <input type="file" onChange={onFileChangeCover}/>
                                                </label>
                                            </span>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    عنوان
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-big-2"
                                           id="floatingInput"

                                           value={title}
                                           onChange={
                                               (event) => {
                                                   setTitle(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    شماره تلفن
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-big-2"
                                           id="floatingInput"

                                           value={supportPhone}
                                           onChange={
                                               (event) => {
                                                   setSupportPhone(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>

                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    آدرس
                                </label>
                                <div className="form-floating mb-3">
                                    <textarea
                                        className="form-control text-center text-big-2"
                                        id="floatingInput"

                                        value={address}
                                        onChange={
                                            (event) => {
                                                setAddress(event.target.value)
                                            }
                                        }
                                    >
                                    </textarea>

                                </div>
                            </div>

                            <div className="col-md-12">
                                <label htmlFor="floatingInput">
                                    توضیحات مختصر
                                </label>
                                <div className="form-floating mb-3">
                                    <textarea
                                        className="form-control text-center text-big-2"
                                        id="floatingInput"

                                        value={brief}
                                        onChange={
                                            (event) => {
                                                setBrief(event.target.value)
                                            }
                                        }
                                    >
                                    </textarea>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    درصد تخفیف در صورت خرید نقدی
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="text"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={cashDiscount}
                                           onChange={
                                               (event) => {
                                                   setCashDiscount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    مهلت چک در خرید غیر نقدی (روز)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={chequeDeadline}
                                           onChange={
                                               (event) => {
                                                   setChequeDeadline(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                            </div>


                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                    حداقل مبلغ خرید (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={minPurchase}
                                           onChange={
                                               (event) => {
                                                   setMinPurchase(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                                <div className='price-hint mt-2'>
                                    {currencyFormat.format(Math.round(minPurchase / 10))}
                                    &nbsp;
                                    تومان
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                  درصد سهم سامانه
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={cooperationPercent}
                                           onChange={
                                               (event) => {
                                                   setCooperationPercent(event.target.value)
                                               }
                                           }
                                    />

                                </div>

                            </div>

                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                   آستانه تخفیف مبلغی (ریال)
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={thresholdDiscount}
                                           onChange={
                                               (event) => {
                                                   setThresholdDiscount(event.target.value)
                                               }
                                           }
                                    />

                                </div>
                                <div className='price-hint mt-2'>
                                    {currencyFormat.format(Math.round(thresholdDiscount / 10))}
                                    &nbsp;
                                    تومان
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                  درصد تخفیف مبلغی
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={discountPercent}
                                           onChange={
                                               (event) => {
                                                   setDiscountPercent(event.target.value)
                                               }
                                           }
                                    />

                                </div>

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="floatingInput">
                                  درصد مالیات
                                </label>
                                <div className="form-floating mb-3">
                                    <input type="number"
                                           className="form-control text-center text-small-1"
                                           id="floatingInput"

                                           value={tax}
                                           onChange={
                                               (event) => {
                                                   setTax(event.target.value)
                                               }
                                           }
                                    />

                                </div>

                            </div>


                            <div className="col-12">
                                <label htmlFor="floatingInput">
                                    توضیحات
                                </label>
                                <div className="form-floating mb-3">
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            setDescription(data);
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="col-md-6 mt-3 form-check form-switch pt-3"
                                 onClick={() => setShowRules(true)}
                            >
                                <label className="form-check-label mx-4" htmlFor="flexSwitchCheckDefault">
                                    <span className='text-primary text-decoration-underline'
                                          role='button'

                                    >قوانین و مقررات سامانه</span>
                                    &nbsp;
                                    پخش من را می پذیرم.
                                </label>
                                <input type="checkbox"
                                       className="form-check-input" role="switch"
                                       id="flexSwitchCheckDefault"
                                       checked={acceptRules}
                                       value={1}

                                />

                            </div>
                            <div className="col-md-6 mt-3">
                                <button className='btn btn-success w-100'
                                        onClick={onClickSaveButton}
                                >
                                    ثبت مجموعه
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default CreateVendor;